import { takeLatest, put, call } from 'redux-saga/effects';

import { history, storage } from '@commons';
import { convidarUsuario } from '../service';
import {
  TABLE_USUARIO,
  INVITE_USUARIO,
  INVITE_USUARIO_PENDING,
  INVITE_USUARIO_SUCCESS,
  INVITE_USUARIO_FAILURE,
} from '../actionTypes';

import { AlertSuccess, AlertError, AlertWarning } from '@components/common/AlertToast';
import { CONFIG_SESSION } from '@handler/common/startSession';

function* sagaInviteUsuario(action) {
  yield put({ type: INVITE_USUARIO_PENDING });

  try {
    var invite = {
        "nomeConta": JSON.parse(storage.get(CONFIG_SESSION)).contaAgrare.nomeConta || JSON.parse(storage.get(CONFIG_SESSION)).contaAgrare.accountName,
        "email": action.data.email.toLowerCase().trim(),
        "idPerfil": action.data.perfilPermissao.id,
    }
    
    try {
        yield call(convidarUsuario, invite);
        
        yield put({ type: INVITE_USUARIO_SUCCESS, registro: action.data });
        yield put({ type: TABLE_USUARIO });
        AlertSuccess('Convite enviado com sucesso!');
    } catch (error) {
        yield put({ type: INVITE_USUARIO_FAILURE, registro: action.data });
        if (error.response?.status === 400 && error.response?.data) {
            AlertError(error.response.data);
        } else {
            AlertError('Falha ao enviar convite! Tente novamente mais tarde.');
        }
    }
  } catch (error) {
    yield put({ type: INVITE_USUARIO_FAILURE, registro: action.data })

    if (error.response?.status == 403) {
      AlertWarning('Sua licença atingiu o número máximo de usuários cadastrados. Para contratar mais usuários, contate o comercial da plataforma.');
    } else {
        if (error.response?.status === 400 && error.response?.data !== undefined) {
            AlertError(error.response?.data ?? 'Falha ao processar envio. Tente novamente...');
        } else {
            AlertError('Falha ao enviar convite! Verifique se o e-mail está cadastrado na plataforma e tente novamente...');
        }
    }
  }
}

export default function* watchInviteUsuario() {
  yield takeLatest(INVITE_USUARIO, sagaInviteUsuario);
}
